export default {
  "Product Thinking": {
    title: "Product Thinking",
    description:
      "Product thinking is a mindset and approach to problem-solving that is focused on creating valuable and meaningful products and experiences for users. It involves understanding the needs and motivations of users, identifying opportunities to create value, and continually iterating and refining the product to meet the evolving needs and expectations of the target audience. Product thinking involves a holistic and user-centered approach to product development, considering not just the technical and functional aspects of the product, but also the emotional and psychological impact it has on users.",
    links: [
      {
        iconType: "article",
        title: "Product Thinking 101",
        href: "https://uxplanet.org/product-thinking-101-1d71a0784f60",
      },
      {
        iconType: "article",
        title: "The Power of Product Thinking",
        href: "https://future.com/product-thinking/",
      },
      {
        iconType: "video",
        title: "Michael Seibel - Building Product",
        href: "https://www.youtube.com/watch?v=C27RVio2rOs",
      },
      {
        iconType: "video",
        title: "How to Get and Test Startup Ideas - Michael Seibel",
        href: "https://www.youtube.com/watch?v=vDXkpJw16os",
      },
      {
        iconType: "book",
        title: "Business Thinking for Designers Handbook, by Ryan Rumsey",
        href: "https://designco-web-assets.s3.amazonaws.com/uploads/2020/04/InVision_BusinessThinkingforDesigners.pdf",
      },
      {
        iconType: "article",
        title: "7 Things Every Designer Should Know About Business",
        href: "https://d.mba/guides/7-things-designer-should-know-about-business#backhere=",
      },
    ],
  },
  "Product Vision": {
    title: "Product Vision",
    description:
      "Product vision is a statement that describes the long-term goals and desired outcomes for a product. It serves as a guiding light for the product team and helps them stay focused on the bigger picture as they work towards building and evolving the product. The product vision should be aspirational and inspire the team to think creatively and strategically about how they can bring the vision to life. It should also be clear and concise, and provide a clear direction for the product team to follow as they make decisions and prioritize their work.",
    links: [
      {
        iconType: "article",
        title: "Product Vision vs. Mission",
        href: "https://www.svpg.com/product-vision-vs-mission/",
      },
      {
        iconType: "article",
        title: "What is a Product Vision Statement?",
        href: "https://www.productplan.com/glossary/product-vision/#:~:text=A%20product%20vision%2C%20or%20product,achieve%20in%20the%20long%20term.",
      },
      {
        iconType: "video",
        title: "3 Things that Make a MEANINGFUL Vision | Simon Sinek",
        href: "https://www.youtube.com/watch?v=zpzZumZCdWA",
      },
    ],
  },

  "Product Strategy": {
    title: "Product Strategy",
    description:
      "Product strategy involves the planning and execution of the development and management of a product or service. It includes identifying the target market, defining the features and benefits of the product, and determining the pricing, distribution, and promotion strategies that will be used to bring the product to market. Effective product strategy requires a deep understanding of the target market, the competition, and the industry landscape, as well as the ability to adapt and adjust the product as needed in response to changing market conditions and customer needs.",
    links: [
      {
        iconType: "article",
        title: "Product Strategy – Overview",
        href: "https://www.svpg.com/product-strategy-overview/",
      },
      {
        iconType: "video",
        title: `Dan Olsen "How to Create Your Product Strategy" at the 2018 NYC Product Leader Summit`,
        href: "https://www.youtube.com/watch?v=11b2JdeHoGM",
      },
      {
        iconType: "video",
        title: "What Is Product Strategy (an overview)",
        href: "https://www.youtube.com/watch?v=ebwo_BX_VtU",
      },
      {
        iconType: "book",
        title: `Blue Ocean Strategy`,
        href: "https://www.amazon.com/Blue-Ocean-Strategy-Uncontested-Competition/dp/1591396190",
      },
      {
        iconType: "article",
        title: "Strategic Planning | Frameworks",
        href: "https://www.atlassian.com/work-management/strategic-planning/framework",
      },
    ],
  },
  "Value Proposition": {
    title: "Value Proposition",
    description:
      "Value proposition is a statement that clearly communicates the benefits and value that a company's product or service offers to its customers. It explains how the product or service solves a problem or fulfills a need, and why it is better than other options on the market. A strong value proposition helps a company stand out from its competitors and attract potential customers by highlighting the unique value it offers.",
    links: [
      {
        iconType: "video",
        title: "Harvard i-lab | Startup Secrets: Value Proposition",
        href: "https://www.youtube.com/watch?v=6pKW-ehL7dU",
      },
      {
        iconType: "article",
        title:
          "How to Write a Great Value Proposition [5 Top Examples + Template]",
        href: "https://blog.hubspot.com/marketing/write-value-proposition",
      },
      {
        iconType: "article",
        title: "What Is a Value Proposition? (+ 8 Winning Examples)",
        href: "https://www.shopify.com/blog/value-proposition",
      },
    ],
  },
  "Product-Market Fit": {
    title: "Product-Market Fit",
    description:
      "Product-market fit refers to the degree to which a product meets the needs of a particular market. It is a measure of how well a product satisfies the demand of a target market and how well it meets the needs of its customers. A product that has a strong product-market fit is well-suited to the needs and preferences of its target market and is able to compete effectively in its market. On the other hand, a product that lacks product-market fit may struggle to gain traction and may ultimately fail in the market. Ensuring that a product has a strong product-market fit is an important step in the process of bringing a product to market and is crucial for the success of any business.",
    links: [
      {
        iconType: "video",
        title: "David Rusenko - How To Find Product Market Fit",
        href: "https://www.youtube.com/watch?v=0LNQxT9LvM0&t=0s",
      },
      {
        iconType: "video",
        title: "The Real Product Market Fit by Michael Seibel",
        href: "https://www.youtube.com/watch?v=FBOLk9s9Ci4",
      },
      {
        iconType: "article",
        title: "A How-To Guide to Product-Market Fit",
        href: "https://medium.com/blackstar/a-how-to-guide-to-product-market-fit-5fb12c6f8f6e",
      },
    ],
  },
  "Product Roadmap": {
    title: "Product Roadmap",
    description:
      "Product roadmap is a high-level visual summary that maps out the vision and direction of a product. It outlines the key features and capabilities that the product team plans to deliver over a specified period of time. A product roadmap serves as a communication tool to align stakeholders on the progress and direction of the product, and to help prioritize the development of new features and enhancements. It can also be used to identify dependencies, track progress, and adjust course as needed to ensure that the product meets the needs of its target market.",
    links: [
      {
        iconType: "article",
        title: "What is a product roadmap?",
        href: "https://www.atlassian.com/agile/product-management/product-roadmaps#:~:text=What%20is%20a%20product%20roadmap,how%20they%20will%20be%20achieved.",
      },
      {
        iconType: "article",
        title: "3 Types of Roadmaps in UX and Product Design",
        href: "https://www.nngroup.com/articles/roadmap-types/",
      },
    ],
  },
  "Product Pitch": {
    title: "Product Pitch",
    description:
      "Product pitch is a presentation that aims to sell a product or service to a potential customer or investor. It typically includes a brief overview of the product or service, its key features and benefits, and how it meets the needs of the target audience. A product pitch may also include demonstrations, samples, or other materials to help illustrate the product or service in action. The goal of a product pitch is to persuade the listener to try the product or service, invest in it, or otherwise engage with it in some way.",
    links: [
      {
        iconType: "video",
        title: "How to Pitch to Investors, Michael Seibel, CEO Y Combinator",
        href: "https://www.youtube.com/watch?v=Q-YBCehpgpc",
      },
      {
        iconType: "article",
        title: "Pitching your early stage startup",
        href: "https://stripe.com/atlas/guides/pitching",
      },
      {
        iconType: "article",
        title: "Want a Better Pitch? Watch This.",
        href: "https://medium.com/firm-narrative/want-a-better-pitch-watch-this-328b95c2fd0b",
      },
      {
        iconType: "article",
        title: "What do I look for in a pitch?",
        href: "https://news.greylock.com/what-do-i-look-for-in-a-pitch-866355bddb3",
      },
      {
        iconType: "article",
        title: "10 Steps to Perfect Your Startup Pitch",
        href: "https://www.gsb.stanford.edu/insights/10-steps-perfect-your-startup-pitch",
      },
    ],
  },
  "Product Launch": {
    title: "Product Launch",
    description:
      "Product launch is the process of introducing a new product or service to the market. It typically involves a series of marketing and communication activities designed to generate interest and demand for the product among potential customers. A product launch may involve a range of activities such as product demonstrations, press releases, advertising, social media campaigns, and promotional events. The success of a product launch can have a significant impact on the overall success of the product and the company.",
    links: [
      {
        iconType: "video",
        title: "Kat Mañalac - How to Launch (Again and Again)",
        href: "https://www.youtube.com/watch?v=3xU050kMbHM",
      },
      {
        iconType: "video",
        title: "When to Launch Your Startup and When to Wait",
        href: "https://www.youtube.com/watch?v=f0tPjcgcwnQ",
      },
      {
        iconType: "article",
        title: "Product Launch Plan: 17 Tips to Ensure a Seamless Launch",
        href: "https://blog.hubspot.com/marketing/elements-flawless-product-launch-li",
      },

      {
        iconType: "article",
        title: "How to plan a successful product market launch",
        href: "https://lubiarz.medium.com/how-to-plan-a-successful-product-market-launch-c34fd5bdc0b9",
      },
    ],
  },
  MVP: {
    title: "MVP",
    description:
      "MVP stands for Minimum Viable Product. It is a product development strategy that involves creating a product with just enough features to allow users to experience its core functionality, while also gathering valuable feedback from early adopters. The goal of an MVP is to quickly test and validate a product idea, gather insights from real users, and iterate based on that feedback, with the ultimate goal of creating a fully-fledged product that meets the needs of its target market. This approach is often used in the technology industry, as it allows companies to bring new products to market faster, while also minimizing the risk of investing too much time and resources in a product that may not be successful.",
    links: [
      {
        iconType: "video",
        title: "Michael Seibel - How to Plan an MVP",
        href: "https://www.youtube.com/watch?v=1hHMwLxN6EM",
      },
      {
        iconType: "article",
        title:
          "Minimum Viable Product (MVP) and Design - Balancing Risk to Gain Reward",
        href: "https://www.interaction-design.org/literature/article/minimum-viable-product-mvp-and-design-balancing-risk-to-gain-reward",
      },
      {
        iconType: "article",
        title: "The Efficient Approach: How to Design a Lean UX MVP",
        href: "https://www.toptal.com/designers/ux/lean-ux-mvp",
      },
    ],
  },
  "Press Release": {
    title: "Press Release",
    description:
      "Press release is a written or recorded communication that is issued to the media for the purpose of announcing something newsworthy. In the context of a digital product, a press release might be used to announce the launch of a new app, software update, or online service. It typically includes information about the product, its features and benefits, and any relevant background information. The press release is designed to generate buzz and interest in the product, and may be distributed to journalists, bloggers, and other influencers in the tech industry in an effort to gain coverage and drive traffic to the product's website or landing page.",
    links: [
      {
        iconType: "article",
        title: "How to Write a Press Release",
        href: "https://blog.hubspot.com/marketing/press-release-template-ht",
      },

      {
        iconType: "article",
        title: "How to Write a Press Release (+ Free Template)",
        href: "https://www.shopify.com/blog/how-to-write-a-press-release",
      },
      {
        iconType: "article",
        title: "10 Tips for Writing a Press Release",
        href: "https://mailchimp.com/resources/writing-press-releases/",
      },
    ],
  },
  "Product Usage Analytics": {
    title: "Product Usage Analytics",
    description:
      "Product usage analytics is the process of collecting, analyzing, and reporting on data related to how a product is being used by its customers. This can include data on how frequently the product is used, which features are being utilized, and how long users spend using the product. This information can be used by product managers and developers to improve the product, identify areas for growth, and better understand the needs of their customers. Product usage analytics can be tracked in a variety of ways, including through the use of software tools, user surveys, and other data-gathering methods.",
    links: [
      {
        iconType: "video",
        title: "Ilya Volodarsky - Analytics for Startups",
        href: "https://www.youtube.com/watch?v=LLerCc7MOQo",
      },
      {
        iconType: "article",
        title: "The Guide to Product Metrics",
        href: "https://mixpanel.com/content/guide-to-product-metrics/full-report/",
      },
      {
        iconType: "article",
        title: "Metrics for Product Management",
        href: "https://mixpanel.com/blog/product-management-metrics-and-analytics/",
      },
      {
        iconType: "book",
        title: "Lean Analytics: Use Data to Build a Better Startup Faster",
        href: "https://www.amazon.com/Lean-Analytics-Better-Startup-Faster-ebook/dp/B00AG66LTM/ref=tmm_kin_swatch_0?_encoding=UTF8&qid=&sr=",
      },
    ],
  },
  "Customer Retention": {
    title: "Customer Retention",
    description:
      "Customer retention refers to the practice of keeping customers coming back to your business over time. It is a key measure of a company's success, as it is typically less expensive to retain an existing customer than it is to acquire a new one. There are many strategies that businesses can use to improve customer retention, including offering high-quality products or services, providing excellent customer service, offering loyalty programs, and continually seeking out ways to improve the customer experience. By focusing on customer retention, businesses can build long-term relationships with their customers, which can lead to increased customer loyalty.",
    links: [
      {
        iconType: "article",
        title: "Designing for User Retention That Works",
        href: "https://uxplanet.org/designing-for-user-retention-that-works-16793351512a",
      },
      {
        iconType: "article",
        title: "How Do the Best Companies Retain Customers?",
        href: "https://uxmag.com/articles/how-do-the-best-companies-retain-customers",
      },
      {
        iconType: "article",
        title:
          "How to measure and improve customer retention using qualitative data",
        href: "https://www.hotjar.com/blog/retention-metrics/",
      },

      {
        iconType: "video",
        title:
          "Customer Retention Strategies - 5 Tips To Increase Lifetime Value",
        href: "https://www.youtube.com/watch?v=28ap1Md-XmY",
      },
      {
        iconType: "video",
        title:
          "Customer Retention 101: How to increase the lifetime value of a customer",
        href: "https://www.youtube.com/watch?v=Y6IBkNNkfJg",
      },
    ],
  },
  "Product Pivot": {
    title: "Product Pivot",
    description:
      "Product pivot refers to the process of significantly changing the focus or direction of a product, often in response to market demand or changing business circumstances. This can involve altering the target customer, business model, features, or positioning of the product. Product pivots can be strategic moves that allow companies to pivot their product towards a new, potentially more profitable market or audience. It can also involve making adjustments to a product in response to customer feedback or changing market conditions. Ultimately, the goal of a product pivot is to improve the product's chances of success in the market.",
    links: [
      {
        iconType: "video",
        title: "Dalton Caldwell - All About Pivoting",
        href: "https://www.youtube.com/watch?v=8pNxKX1SUGE",
      },
      {
        iconType: "article",
        title: "14 Famous Business Pivots",
        href: "https://www.forbes.com/sites/jasonnazar/2013/10/08/14-famous-business-pivots/?sh=241b6e785797",
      },
    ],
  },
  "Business Metrics": {
    title: "Business Metrics",
    description:
      "Business metrics are quantifiable measures that organizations use to track and assess the success of their operations. These metrics can be financial, such as revenue and profitability, or they can be non-financial, such as customer satisfaction and employee engagement. Businesses use metrics to set goals, assess performance, and make data-driven decisions to improve their operations and achieve their objectives. ",
    links: [
      {
        iconType: "video",
        title: "How to Set KPIs and Goals (SUS 2019)",
        href: "https://www.ycombinator.com/library/6j-how-to-set-kpis-and-goals-sus-2019",
      },
      {
        iconType: "video",
        title: "Michael Seibel - How to set your KPI?",
        href: "https://www.youtube.com/watch?v=kJIBAp48Pv8",
      },

      {
        iconType: "video",
        title: "Kevin Hale - How to Improve Conversion Rates",
        href: "https://www.youtube.com/watch?v=PGqX9fpweyc",
      },
      {
        iconType: "article",
        title: "Top 10 Product Metrics",
        href: "https://chartio.com/learn/product-analytics/top-product-metrics/",
      },
    ],
  },
  "Design Metrics": {
    title: "Design Metrics",
    description:
      "Design metrics are measurements or indicators used to assess the performance or effectiveness of a design. They can be used to evaluate a wide range of design elements, including user experience, usability, aesthetics, and functionality. Design metrics are often used by designers and developers to identify areas for improvement and to track progress over time. They can be collected through a variety of methods, such as user testing, analytics, or surveys, and are typically used in conjunction with other design tools and techniques to help inform the design process and ensure that a product or service meets the needs and expectations of its users.",
    links: [
      {
        iconType: "article",
        title: "Choosing the Right Metrics for User Experience",
        href: "https://www.uxmatters.com/mt/archives/2014/06/choosing-the-right-metrics-for-user-experience.php",
      },
      {
        iconType: "article",
        title: "A Quick Guide to UX Metrics",
        href: "https://uxplanet.org/a-quick-guide-to-ux-metrics-d271a937149a",
      },
      {
        iconType: "article",
        title: "How to estimate the ROI of design work",
        href: "https://www.invisionapp.com/inside-design/estimate-roi-design-work/",
      },

      {
        iconType: "video",
        title: "The HEART Framework",
        href: "https://www.youtube.com/watch?v=YugESrDVHuo",
      },
    ],
  },
};
